import { watch } from '@vue/composition-api';

import type { User } from '@/modules/advisor-search/api/useUsersApi';

import { useTeamId } from '@/modules/teamplan/utils/provideTeamId';
import { useTopicBookmarkStatusesWithSWRV } from '@/modules/advisor-search/api/useTopicBookmarkStatusesWithSWRV';

export const useAdvisorSearchUsers = (
  props: {
    userId: number | null;
    users: User[];
  },
  isSp: boolean,
) => {
  if (props.userId && (isSp || !useTeamId())) {
    const { validateByTopicIds } = useTopicBookmarkStatusesWithSWRV();
    watch(
      () => props.users.flatMap(user => user.topics.map(topic => topic.id)),
      topicIds => {
        validateByTopicIds(topicIds);
      },
      { immediate: true, deep: true },
    );
  }
};
